import { OptionType } from '../plan/option-type';
import { IValidation } from '../validation/validation';

export interface IBasicOptionInput {
  optionType: OptionType;
  isOptedIn: boolean;
  optedInTotalValue?: number;
  optedInOffsetValue?: number;
  validation?: IValidation;
}

export const emptyBasicOption: Partial<IBasicOptionInput> = {
  isOptedIn: false,
  optedInTotalValue: undefined,
  optedInOffsetValue: undefined,
  validation: {
    isValid: true,
    errors: [],
  },
};
